export enum WorkflowType {
    ONLINE_APPOINTMENT = 1,
    ONLINE_PAYMENT = 2,
    MEDICAL_ORDER = 3,
    GROWTH_CURVES = 4
}
